import script from "./ErrorOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorOverlay.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/modules/ErrorOverlay.css?vue&type=style&index=0&id=564e3d20&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-564e3d20"]])

export default __exports__